<template>
  <div class="grid-container philly-stat">
    <div class="grid-x container mvxl">
      <div class="content cell medium-13">
        <h2 class="title">
          Philly Stat 360
        </h2>
        <div class="subtitle">
          {{ $t("philly-stat-360.data-subheader") }}
        </div>
        <div class="ptm">
          <a
            class="button"
            href="https://philly-stat-360-phl.hub.arcgis.com/"
          >
            {{ $t("mayor.learn-more") }}
            <i
              class="fas fa-angle-right fa-lg"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
      <div class="img-container">
        <img src="https://www.phila.gov/assets/images/website/phillystat360.png">
      </div>
    </div>
  <!--
    <div class="grid-x container mvxl">
      <div class="content cell medium-13">
        <h2 class="title">
          Voting
        </h2>
        <div class="subtitle">
          Election Day is Nov. 5, 2024. Find your polling place, ballot drop box locations, and other important information for voters.
        </div>
        <div class="ptm">
          <a
            class="button"
            href="https://vote.phila.gov/"
          >
            Learn more
            <i
              class="fas fa-angle-right fa-lg"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
      <div class="img-container">
        <img
          src="https://www.phila.gov/assets/images/website/vote.png"
          alt=""
        >
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() { },
  methods: {},
};
</script>
